import { httpRequest } from "../../http";
import { LaunchAd } from "@models/launchAd";
import { EngagementAction } from "@models/engagementAction";
import { TodoSerializer } from "@models/serializers/todoSerializer";

interface ActionReviewResponse {
  id: number;
  type: "APPROVE" | "REVIEW" | "REBRAND";
  is_active: boolean;
  assigned_roles: string[];
  engagement_id: number;
  launch_ad_id: number;
  launch_ad_status: string | null;
  ad: any;
  review_todo: any;
}

/**
 * Fetches everything the review page needs in one call, gated by the
 * action's own access policy. Replaces the older launch-ad detail call.
 */
export class CommandGetActionReview {
  async run(actionId: number): Promise<LaunchAd> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/actions/${actionId}/`;
    const data = await httpRequest<ActionReviewResponse>(url, { method: "GET" });

    const action = new EngagementAction({
      id: data.id,
      type: data.type,
      is_active: data.is_active,
      assigned_roles: data.assigned_roles,
      engagement_id: data.engagement_id,
      launch_ad_id: data.launch_ad_id,
    });

    return new LaunchAd({
      id: data.launch_ad_id,
      status: (data.launch_ad_status ?? "TODO") as any,
      review_todo: data.review_todo
        ? new TodoSerializer().deserialize(data.review_todo)
        : null,
      review_todo_id: data.review_todo?.id,
      ad: data.ad,
      my_action: action,
    });
  }
}
